module.exports = __webpack_public_path__ + "fonts/Inter-Bold.woff2";